// extracted by mini-css-extract-plugin
module.exports = {"root":"footer-module--root--24vR9","container":"footer-module--container--2iXoO","links":"footer-module--links--9DoeT","socialNav":"footer-module--socialNav--3IxdK"};